import { VerifiedBadge } from '@eventbrite/verified-badge';
import React from 'react';

import { useOrganizerQualityInfo } from '../../../../../contexts/OrganizerContext';
import { ListingsAvatar } from './ListingsAvatar';
import styles from './ListingsAvatarBadge.module.scss';
import { IListingsAvatarWithBadgeProps } from './types';

export const ListingsAvatarWithBadge: React.FC<
    IListingsAvatarWithBadgeProps
> = ({ featureFlags, verifiedBadgeIconSize, onClick, avatarSize }) => {
    const { creatorBadgeData } = useOrganizerQualityInfo();
    const showVerifiedBadge = creatorBadgeData?.showBadge || false;

    const avatarJSX = (
        <ListingsAvatar featureFlags={featureFlags} size={avatarSize} />
    );

    return showVerifiedBadge ? (
        <VerifiedBadge
            addOnClasses={styles.listingsAvatarWithBadgeContainer}
            onClick={onClick}
            iconSize={verifiedBadgeIconSize}
            showBorder={false}
            useCustomIcon={true}
        >
            {avatarJSX}
        </VerifiedBadge>
    ) : (
        avatarJSX
    );
};
